import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route } from "react-router-dom";
import { FaroRoute } from '@grafana/faro-react';
// import Mocker from "utils/Mocker";

// TODO: This filename should change when you update your application
import Starter from "./Starter";
import config from "../config.json";

import "./App.css";

// Mocker();
let RouteMaker = Route;

if(config.grafanaURL){
	RouteMaker = FaroRoute;
}

export default function App(props){
	return (
		<Provider store={props.store}>
			<ConnectedRouter history={props.history}>
				<RouteMaker path="/" component={Starter} />
			</ConnectedRouter>
		</Provider>
	);
}
